import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import logo from "../../assets/logo.png";

const Navbars = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600&family=Montserrat:wght@500;600&family=Lato:wght@300;400&display=swap');

        .main-navbar {
          background: linear-gradient(135deg, #1a0f00 0%, #2c1a00 100%);
          padding: 0;
          box-shadow: 0 2px 24px rgba(0,0,0,0.4);
          border-bottom: 1px solid rgba(196,138,20,0.18);
        }

        .main-navbar .container {
          min-height: 68px;
          display: flex;
          align-items: center;
        }

        .brand {
          display: flex;
          align-items: center;
          gap: 14px;
          text-decoration: none;
        }

        .brand-logo {
          width: 44px;
          height: 44px;
          object-fit: contain;
          border-radius: 50%;
          border: 1.5px solid rgba(196,138,20,0.35);
          padding: 3px;
          background: rgba(255, 255, 255, 0.65);
        }

        .brand-text {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .brand-title {
          font-family: 'Playfair Display', serif;
          font-size: 17px;
          font-weight: 600;
          color: #f0c060;
          letter-spacing: 0.3px;
          line-height: 1;
          white-space: nowrap;
        }

        .brand-sub {
          font-family: 'Lato', sans-serif;
          font-size: 10px;
          font-weight: 300;
          color: rgba(253,248,240,0.4);
          letter-spacing: 2.5px;
          text-transform: uppercase;
        }

        .nav-divider {
          width: 1px;
          height: 28px;
          background: rgba(196,138,20,0.2);
          margin: 0 28px 0 auto;
        }

        .nav-links .nav-link {
          font-family: 'Montserrat', sans-serif;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: rgba(253,248,240,0.65) !important;
          padding: 8px 14px !important;
          border-radius: 6px;
          transition: color 0.2s ease, background 0.2s ease;
          margin-left: 4px;
        }
        .nav-links .nav-link:hover {
          color: #f0c060 !important;
          background: rgba(196,138,20,0.1);
        }

        .main-navbar .navbar-toggler {
          border: 1px solid rgba(196,138,20,0.3);
          border-radius: 8px;
          padding: 6px 10px;
        }
        .main-navbar .navbar-toggler:focus { box-shadow: none; }
        .main-navbar .navbar-toggler-icon {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(240,192,96,0.8)' stroke-width='2.2' stroke-linecap='round' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
        }

        @media (max-width: 991px) {
          .nav-divider { display: none; }
          .main-navbar .navbar-collapse {
            background: #1a0f00;
            border-top: 1px solid rgba(196,138,20,0.12);
            padding: 8px 0 14px;
          }
          .nav-links .nav-link {
            margin-left: 0;
            border-radius: 0;
            padding: 12px 20px !important;
            border-bottom: 1px solid rgba(196,138,20,0.07);
            text-align: center;
            letter-spacing: 2.5px;
          }
          .nav-links .nav-link:last-child { border-bottom: none; }
        }
      `}</style>

      <Navbar expand="lg" className="main-navbar" sticky="top">
        <Container>
          <Navbar.Brand href="/" className="brand">
            <img src={logo} alt="Logo" className="brand-logo" />
            <div className="brand-text">
              <span className="brand-title">Acharya Tarun Kumar Sah</span>
              <span className="brand-sub">Vastu · Astro · Numerology</span>
            </div>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-navbar-nav" />

          <Navbar.Collapse id="main-navbar-nav">
            <div className="nav-divider d-none d-lg-block" />
            <Nav className="nav-links">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="#contact">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Navbars;